import React from 'react';

export const EventLocation = ({ displayEventSettings, event }) => {
  return (
    <p className="location">
      {displayEventSettings['ShowEventVenue'] && event.venue ? event.venue : null}
      {displayEventSettings['ShowEventVenue'] && event.venue && displayEventSettings['ShowEventCity'] && event.city ? ', ' : null}
      {displayEventSettings['ShowEventCity'] && event.city ? event.city : null}
    </p>
  );
};
